import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

function WeatherApp() {
  const [city, setCity] = useState("");
  const [weatherData, setWeatherData] = useState(null);
  const smiley = String.fromCodePoint(0x1f604); // Unicode code point for smiley emoji
  useEffect(() => {
    if (city) {
      const API_KEY = "19a78b423c92683ffe5f539b0d3e1933";
      const API_URL = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}&units=metric`;

      axios
        .get(API_URL)
        .then((response) => {
          setWeatherData(response.data);
        })
        .catch((error) => {
          console.error(error);
          setWeatherData(null);
        });
    }
  }, [city]);

  return (
    <div className="weather-app container">
      <div className="background-image"></div>
      <h1 className="mt-4">Weather App</h1>
      <form onSubmit={(e) => e.preventDefault()} className="mb-4">
        <input
          type="text"
          className="form-control"
          placeholder="Enter city name"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <button type="submit" className="btn btn-warning mt-2">
          Get Weather
        </button>

        {weatherData && (
          <div className="weather-info">
            <h2>
              {weatherData.name}, {weatherData.sys.country}
            </h2>
            <h5>{weatherData.weather[0].description}</h5>
            <h5>Temperature: {weatherData.main.temp}°C</h5>
            <h5>Feels Like: {weatherData.main.feels_like}°C</h5>
            <h5>Min Temperature: {weatherData.main.temp_min}°C</h5>
            <h5>Max Temperature: {weatherData.main.temp_max}°C</h5>
            <h5>Humidity: {weatherData.main.humidity}%</h5>
            <h5>Wind Speed: {weatherData.wind.speed} m/s</h5>
            <h5>Cloudiness: {weatherData.clouds.all}%</h5>
          </div>
        )}
        <h3>{smiley} Have A Nice Day</h3>
      </form>
    </div>
  );
}

export default WeatherApp;
